module.exports = __webpack_public_path__ + "static/media/april_2025.22a14a7d.png";